import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {Router} from '@angular/router';
import {inject} from '@angular/core';

/**
 * Inspects the response for a 404 error and navigates to the not-found page if detected. The organization ID is
 * extracted from the URL to ensure the user is directed to the appropriate context.
 * @param {HttpRequest<unknown>} req
 * @param {HttpHandlerFn} next
 * @returns {Observable<HttpEvent<any>>}
 */
export function notFoundInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<any>> {
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 404) {
        const currentUrl = router.url;
        const orgIdMatch = currentUrl.match(/\/org\/([^/]+)/);
        const orgId = orgIdMatch ? orgIdMatch[1] : 'current';

        router.navigate(['/org', orgId, 'commerce', 'not-found']);
      }

      return throwError(() => error);
    })
  );
}
